export default "__VITE_ASSET__KK4HCjf5__"